var map = {
	"./abbv-blue.svg": 1442,
	"./abbv-consent.svg": 1443,
	"./abbv-page.png": 702,
	"./abbv-white.svg": 1210,
	"./bayer-light.svg": 1209,
	"./bayer.svg": 1444,
	"./default.svg": 1445,
	"./navi.svg": 1446
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1441;